
import mixinFlexItem from './mixin-flex-item'

export default {
  name: 'VsStackItem',
  mixins: [
    mixinFlexItem
  ],
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    default: {
      $attrs: 'all'
    }
  }
}
